import * as React from "react";
const SvgFiRrGaugeCircleMinus = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="#062147" clipPath="url(#fi-rr-gauge-circle-minus_svg__a)">
      <path d="M18 12a6 6 0 1 0 0 12 6 6 0 0 0 0-12m2.5 7h-5a1 1 0 1 1 0-2h5a1 1 0 1 1 0 2M13 11c0-.738-.405-1.376-1-1.723V5a1 1 0 0 0-2 0v4.277c-.595.346-1 .984-1 1.723a2 2 0 1 0 4 0" />
      <path d="m6.71 16.607-.934.807a.823.823 0 0 1-1.11-.029C2.66 15.4 1.716 12.641 2.075 9.82c.513-4.042 3.828-7.305 7.879-7.76 5.1-.567 9.498 3.072 9.999 8.02a1.001 1.001 0 0 0 1.991-.202C21.33 3.831 15.893-.618 9.732.071 4.774.627.719 4.621.09 9.567c-.437 3.445.718 6.812 3.168 9.24a2.8 2.8 0 0 0 1.976.806c.658 0 1.319-.228 1.849-.686l.933-.807a1 1 0 1 0-1.307-1.513" />
    </g>
    <defs>
      <clipPath id="fi-rr-gauge-circle-minus_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrGaugeCircleMinus;
